module.exports = __webpack_public_path__ + "c0304e8d177753ee2df097cf4e879426.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/img_SM_EXPANDED_W_1200px_H_660px.jpg
// module id = 397
// module chunks = 0